enum Category {
    DOMESTIC = "House keeping",
    BUSINESS = "Business cleaning",
    LAUNDRY = "Laundry service",
}

export default Category